"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef, useContext } from "react";
import { cn } from "../../utils/cn.js";
import { drawerVariants } from "./Drawer.variants.js";
import { DrawerInsetContext } from "./DrawerPortal.js";
import { useResponsiveDrawerDirection } from "./useResponsiveDrawerDirection.js";
const DrawerViewport_DrawerViewport = /*#__PURE__*/ forwardRef(function({ className, slots, direction, size, ...props }, ref) {
    const isInsetActive = useContext(DrawerInsetContext);
    const effectiveDirection = useResponsiveDrawerDirection(direction, isInsetActive);
    const { viewport } = drawerVariants({
        direction: effectiveDirection,
        size
    });
    return /*#__PURE__*/ jsx(Drawer.Viewport, {
        ref: ref,
        className: cn(viewport(), true === isInsetActive && 'absolute inset-2', className, slots?.viewport),
        ...props
    });
});
export { DrawerViewport_DrawerViewport as DrawerViewport };
